import {Modal, Row, Col, Table} from 'react-bootstrap';

export const TotalSpend = ({showModal, closeModal, totalSpends, helper}) => {
  const getCurrentYear = () => new Date().getFullYear();
  const subtractYears = (years) => getCurrentYear() - years;

  return(
    <Modal show={showModal} onHide={closeModal} dialogClassName="activity-filter-modal" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
        Last 5 Years
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Year</th>
              <th>Full Year Revenue</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{getCurrentYear()}</td>
              <td>{helper(totalSpends.YTD)}</td>
            </tr>
            <tr>
              <td>{subtractYears(1)}</td>
              <td>{helper(totalSpends.LCY)}</td>
            </tr>
            <tr>
              <td>{subtractYears(2)}</td>
              <td>{helper(totalSpends.L2Y)}</td>
            </tr>
            <tr>
              <td>{subtractYears(3)}</td>
              <td>{helper(totalSpends.L3Y)}</td>
            </tr>
            <tr>
              <td>{subtractYears(4)}</td>
              <td>{helper(totalSpends.L4Y)}</td>
            </tr>
            <tr>
              <td>{subtractYears(5)}</td>
              <td>{helper(totalSpends.L5Y)}</td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  )
}